import { useCustomWebkitScrollbar } from './useCustomWebkitScrollbar.js';
import 'react';
import '@alfalab/hooks';
import '../browser.js';
import '../isClient.js';

var hooks = {
    useCustomWebkitScrollbar: useCustomWebkitScrollbar,
};

export { hooks };
